var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgQa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#qa_svg__clip0_1162_30320)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.756 18.987a1.609 1.609 0 01-1.485 1.43l-.191.013a.9.9 0 00-.84.898v1.79c0 .603-.69.945-1.169.58-.874-.666-2.038-1.657-2.752-2.684a.898.898 0 00-.744-.383 87.662 87.662 0 01-6.593-.214 1.606 1.606 0 01-1.485-1.426 40.869 40.869 0 010-8.92 1.606 1.606 0 011.485-1.426 87.61 87.61 0 0112.289 0c.774.054 1.4.654 1.485 1.426a40.86 40.86 0 010 8.916z",
    fill: "#597EF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.235 10.5a1.547 1.547 0 001.428 1.375l.184.013c.454.03.807.408.807.863v1.722a.7.7 0 001.124.558c.841-.64 1.96-1.594 2.646-2.582a.863.863 0 01.716-.368c2.113.01 4.226-.057 6.34-.206a1.545 1.545 0 001.427-1.371 39.304 39.304 0 000-8.577A1.545 1.545 0 0013.48.555a84.243 84.243 0 00-11.817 0A1.545 1.545 0 00.235 1.927a39.29 39.29 0 000 8.573z",
    fill: "#FED363"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.113 6.831l-.027-.1a.702.702 0 01.45-.847l1.075-.368c.385-.132.8.09.906.482l.067.252a.702.702 0 01-.543.87l-1.114.219a.702.702 0 01-.814-.508zM19.397 4.437l-.074-.074a.702.702 0 01-.032-.958l.746-.856a.702.702 0 011.026-.035l.184.183a.702.702 0 01-.036 1.026l-.856.746a.702.702 0 01-.958-.032zM17.03 2.674l-.101-.027a.702.702 0 01-.508-.814L16.64.72a.702.702 0 01.87-.543l.252.067a.702.702 0 01.482.906l-.368 1.074a.702.702 0 01-.846.45z",
    fill: "#F0F5FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "qa_svg__clip0_1162_30320"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}

export default __webpack_public_path__ + "./fonts/qa.cabf4a23af69443d6d132d419f60f18e.svg";
export { SvgQa as ReactComponent };